import React, {useEffect, useState} from 'react';
import Layout from "../Layout";
import * as Yup from "yup";
import {useDispatch, useSelector} from "react-redux";
import {Formik, Field} from "formik";
import {changePassword} from "../../Services/apis";
import {REMOVE_USER_DATA, SET_TOAST_PROPS} from "../../Redux/types";
import {goBack} from "../../Utils/helpers";


const AccountDetails = ({history}) => {
    const {isAuthenticated, user} = useSelector(state => state.auth);

    useEffect(() => {
        if(!isAuthenticated)
            history.replace('/');
    },  [isAuthenticated]);


    return (
        <Layout
            headerLeft={
                <div className="h-s__wrap-trigger px15 py10" onClick={() => goBack(history)}>
                    <i className="icon-back" />
                    <span className="d-ib ml5">Back</span>
                </div>
            }>
            <div className="page-title"> Account Details</div>
            <div className="main-content bg-white">

                <div className="personal__details p15">
                    <div className="personal__details-top">
                        <div className="table-f">
                            <div>Account Id</div>
                            <div>4245588</div>
                        </div>
                        <div className="table-f mt5">
                            <div>First Name(s)</div>
                            <div>SOPI</div>
                        </div>
                        <div className="table-f mt5">
                            <div>Surname</div>
                            <div>IBANIBO</div>
                        </div>
                        <div className="table-f mt5">
                            <div>Email<span className="txt-orange"></span></div>
                            <div>elsopi02@yahoo.com</div>
                        </div>
                        <div className="table-f mt5">
                            <div>Date of birth</div>
                            <div>04/03/1998</div>
                        </div>
                        <div className="table-f mt5">
                            <div>Contact Number</div>
                            <div>2347035725999</div>
                        </div>
                        <div className="table-f mt5">
                            <div>Address</div>
                            <div>Ozuboko</div>
                        </div>
                        <div className="table-f mt5">
                            <div>City</div>
                            <div>Port Harcourt</div>
                        </div>
                        <div className="table-f mt5">
                            <div>State</div>
                            <div>RIVERS</div>
                        </div>
                        <div className="table-f mt5">
                            <div>Post code</div>
                            <div>-</div>
                        </div>
                        <div className="table-f mt5">
                            <div>Country</div>
                            <div>NG</div>
                        </div>
                    </div>

                </div>
            </div>
        </Layout>
    );
}


export default AccountDetails;
